/*eslint-disable*/
// chakra imports
import {
  Box, useColorModeValue, BoxProps, Button, Icon
} from "@chakra-ui/react";
import React, { useRef, RefObject } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import SidebarContent from "./SidebarContent";
import { RouteConfigArray } from "../../types/routes";
import { SIDEBAR_FULL_TRANSITION } from "../../constants/transitions";

interface SidebarProps extends BoxProps {
  logoText?: string;
  routes: RouteConfigArray;
  sidebarVariant?: string;
  display?: string;
  isCollapsed?: boolean;
  onToggleSidebar?: () => void;
  onOpen?: () => void;
}

function Sidebar(props: SidebarProps) {
  // to check for active links and opened collapses
  const mainPanel = useRef<HTMLDivElement>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);
  let variantChange = "0.2s linear";

  const { logoText, routes, sidebarVariant, isCollapsed = false, onToggleSidebar, onOpen } = props;

  //  BRAND
  //  Chakra Color Mode
  // Both variants use the same styling, only background differs
  const sidebarBg = sidebarVariant === "opaque" 
    ? useColorModeValue("white", "#151517")
    : "none";
  const sidebarRadius = "0";
  const sidebarMargins = "0";
  const sidebarHeight = "100vh"; // Full viewport height, flush with edges
  const sidebarWidth = isCollapsed ? "80px" : "260px";
  const collapseButtonRight = "-14px";
  // When collapsed: equidistant from top and divider below logo (~95px). When expanded: align with content.
  const collapseButtonTop = isCollapsed ? "30px" : "36px";
  // Center icons when collapsed, use padding when expanded
  const sidebarPaddingLeft = isCollapsed ? "0" : "16px";
  const sidebarPaddingRight = isCollapsed ? "0" : "16px";
  // No bottom padding needed since profile box is absolutely positioned
  const sidebarPaddingBottom = "0";

  // Smooth transition for sidebar - matching MainPanel timing exactly (no delay for immediate sync)
  const sidebarTransition = SIDEBAR_FULL_TRANSITION;

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box ref={sidebarRef} display={{ sm: "none", xl: "block" }} position="fixed" top={0} left={0} bottom={0} w={sidebarWidth} minW={sidebarWidth} overflow="visible" transition={sidebarTransition}>
        <Box
          bg={sidebarBg}
          transition={sidebarTransition}
          w={sidebarWidth}
          maxW={sidebarWidth}
          h={sidebarHeight}
          ps={sidebarPaddingLeft}
          pe={sidebarPaddingRight}
          pb={sidebarPaddingBottom}
          m={sidebarMargins}
          borderRadius={sidebarRadius}
          display="flex"
          flexDirection="column"
          overflow="hidden"
          style={{
            willChange: 'width, max-width, padding',
            backfaceVisibility: 'hidden',
            transform: 'translateZ(0)',
          }}
        >
          <SidebarContent 
            routes={routes}
        logoText={logoText || "PURITY UI DASHBOARD"}
        display="none"
        sidebarVariant={sidebarVariant}
            isCollapsed={isCollapsed}
            onToggleSidebar={onToggleSidebar}
            onOpen={onOpen}
            sidebarRef={sidebarRef}
        />
        </Box>
        {onToggleSidebar && (
          <Button
            onClick={onToggleSidebar}
            variant="ghost"
            size="sm"
            minW="auto"
            w="28px"
            h="28px"
            p="0"
            position="absolute"
            right={collapseButtonRight}
            top={collapseButtonTop}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="transparent"
            zIndex={9999}
            pointerEvents="auto"
            _hover={{ opacity: 0.8 }}
            _active={{ transform: "scale(0.95)" }}
            transition="all 0.2s ease-linear"
            style={{ pointerEvents: "auto" }}
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <Box
              w="28px"
              h="28px"
              borderRadius="full"
              bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              transition="transform 0.2s"
              _hover={{ transform: "scale(1.05)" }}
              boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
              pointerEvents="auto"
            >
              <Icon
                as={isCollapsed ? IoIosArrowForward : IoIosArrowBack}
                w="14px"
                h="14px"
                color="white"
                pointerEvents="none"
              />
            </Box>
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default Sidebar;

